<template>
  <div>
    <div class="first">
      <div class="title"><span class="circle" />受试者随机号设置</div>
      <div class="detail">
        <!--筛选号-->
        <div>
          <el-row class="item">
            <el-col :span="4" class="right">
              <el-input
                v-model="
                  choice_code_another_name === '其他'
                    ? other_name
                    : choice_code_another_name
                "
                size="mini"
                type="text"
                :disabled="isLock"
              />
            </el-col>
            <el-col :span="12" class="rights">
              ：
              <el-radio-group
                v-model="choice_code_another_name"
                :disabled="isLock"
              >
                <el-radio label="筛选号">筛选号</el-radio>
                <el-radio label="随机号">随机号</el-radio>
                <el-radio label="受试者ID">受试者ID</el-radio>
                <el-radio label="受试者编号">受试者编号</el-radio>
                <el-radio label="其他">其他</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="2">
              <el-input
                v-if="choice_code_another_name === '其他'"
                v-model="other_name"
                size="mini"
                :disabled="isLock"
              />
            </el-col>
            <el-col :span="6" class="rights" style="text-align: center">
              <el-checkbox
                v-model="is_choice_code_system"
                :disabled="isLock"
                @change="isSystem"
                >系统生成</el-checkbox
              >

              <el-checkbox
                v-model="is_register_unique_choice_code"
                :disabled="isLock"
                >唯一标识项</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="8" style="text-align: left">
              <el-row>
                <el-col :span="7" class="right" style="text-align: right"
                  >是否需要前缀：</el-col
                >
                <el-col :span="10" class="rights">
                  <el-radio-group
                    v-model="is_need_choice_code_prefix"
                    :disabled="isLock"
                    @change="handleIsPrefix"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <template v-if="is_need_choice_code_prefix">
              <el-col :span="8">
                <el-row :gutter="5">
                  <el-col :span="6" class="right" style="text-align: right"
                    >前缀：</el-col
                  >
                  <el-col :span="6">
                    <el-input
                      v-model="choice_code_prefix"
                      size="mini"
                      :disabled="disPrefix || isLock"
                    />
                  </el-col>
                  <el-col :span="12">
                    <el-select
                      v-model="choice_code_prefix_type"
                      placeholder="请选择"
                      size="mini"
                      :disabled="disPrefix || isLock"
                    >
                      <el-option
                        v-for="(item, e) in inputType"
                        :key="e"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row style="text-align: right">
                  <el-col :span="12" class="right">前缀分隔符：</el-col>
                  <el-col :span="8">
                    <el-input
                      v-model="choice_code_prefix_sep"
                      size="mini"
                      :disabled="disPrefix || isLock"
                      type="text"
                    />
                  </el-col>
                </el-row>
              </el-col>
            </template>
          </el-row>
          <el-row class="item"></el-row>
          <el-row class="item">
            <el-col :span="8">
              <el-row>
                <el-col :span="7" class="right" style="text-align: right"
                  >编号长度：</el-col
                >
                <el-col :span="12">
                  <el-input
                    v-model="choice_code_len"
                    size="mini"
                    :disabled="isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="right" style="text-align: right"
                  >起始编号：</el-col
                >
                <el-col :span="14">
                  <el-input
                    v-model="choice_code_start"
                    size="mini"
                    :disabled="disableSys || isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row style="text-align: right">
                <el-col :span="12" class="right">编号规则：</el-col>
                <el-col :span="8">
                  <el-select
                    v-model="choice_code_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="disableSys || isLock"
                  >
                    <el-option
                      v-for="(item, a) in choiceList"
                      :key="a"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="8">
              <el-row>
                <el-col :span="7" class="right" style="text-align: right"
                  >是否需要后缀：</el-col
                >
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_need_choice_code_suffix"
                    :disabled="isLock"
                    @change="handelIsSuffix"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8" v-if="is_need_choice_code_suffix">
              <el-row :gutter="5">
                <el-col :span="6" class="right" style="text-align: right"
                  >后缀：</el-col
                >
                <el-col :span="6">
                  <el-input
                    v-model="choice_code_suffix"
                    size="mini"
                    :disabled="disSuffix || isLock"
                  />
                </el-col>
                <el-col :span="12">
                  <el-select
                    v-model="choice_code_suffix_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="disSuffix || isLock"
                  >
                    <el-option
                      v-for="(item, b) in choiceType"
                      :key="b"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--姓名-->
    <div class="three">
      <div class="detail">
        <el-row class="item">
          <el-col :span="14">
            <el-row>
              <el-col :span="8" class="right">
                <el-input
                  v-model="initials_another_name"
                  size="mini"
                  :disabled="isLock"
                />
              </el-col>
              <el-col :span="16" class="rights" style="text-align: right">
                <el-col :span="8" class="right" style="text-align: right"
                  >长度选项：</el-col
                >
                <el-col :span="10" style="text-align: left">
                  <el-select
                    v-model="register_new_type_condition"
                    class="input"
                    placeholder=" "
                    size="mini"
                    :disabled="isLock"
                  >
                    <el-option label="最大位数" value="最大位数" />
                    <el-option label="强制位数" value="强制位数" />
                  </el-select>
                </el-col>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row>
              <el-col :span="7" class="right" style="text-align: right"
                >姓名缩写长度：</el-col
              >
              <el-col :span="10" style="text-align: left">
                <el-select
                  v-model="initials_len"
                  placeholder="请选择"
                  size="mini"
                  :disabled="isLock"
                >
                  <el-option
                    v-for="(item, w) in ageList"
                    :key="w"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="8" style="text-align: left">
            <el-row>
              <el-col :span="7" class="right" style="text-align: right"
                >是否需要前缀：</el-col
              >
              <el-col :span="10" class="rights">
                <el-radio-group
                  v-model="register_is_prefix"
                  :disabled="isLock"
                  @change="handleIsPrefix"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-col>
          <template v-if="register_is_prefix === 1">
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="6" class="right" style="text-align: right"
                  >前缀：</el-col
                >
                <el-col :span="6">
                  <el-input
                    v-model="register_prefix"
                    size="mini"
                    :disabled="disPrefix || isLock"
                  />
                </el-col>
                <el-col :span="12">
                  <el-select
                    v-model="register_prefix_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="disPrefix || isLock"
                  >
                    <el-option label="单位编号" value="单位编号" />
                    <el-option label="手动输入" value="手动输入" />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row style="text-align: right">
                <el-col :span="12" class="right">前缀分隔符：</el-col>
                <el-col :span="8">
                  <el-input
                    v-model="register_prefix_sep"
                    size="mini"
                    :disabled="disPrefix || isLock"
                    type="text"
                  />
                </el-col>
              </el-row>
            </el-col>
          </template>
        </el-row>
        <el-row class="item" v-if="register_prefix_type === '手动输入'">
          <el-col :span="8" style="opacity: 0">123</el-col>
          <el-col :span="8">
            <el-row :gutter="5">
              <el-col :span="7" class="right" style="text-align: right">
                前缀长度：</el-col
              >
              <el-col :span="6">
                <el-input-number
                  v-model="register_prefix_length"
                  :min="0"
                  size="mini"
                  :disabled="disAllRandom || isShowSuffix || isLock"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 新字段 -->
    <div class="three" v-for="(item, index) in new_parameter_list" :key="index">
      <div class="detail">
        <el-row class="item">
          <el-col :span="14">
            <el-row>
              <el-col :span="8" class="right">
                <el-input
                  v-model="item.new_parameter_name"
                  size="mini"
                  :disabled="isLock"
                />
              </el-col>
              <el-col :span="16" class="rights" style="text-align: right">
                <el-col :span="8" class="right" style="text-align: right"
                  >字段类型：</el-col
                >
                <el-col :span="10" style="text-align: left">
                  <el-select
                    v-model="item.new_parameter_type"
                    class="input"
                    placeholder=" "
                    size="mini"
                    :disabled="isLock"
                  >
                    <el-option label="数值型" value="数值型" />
                    <el-option label="文本型" value="文本型" />
                    <el-option label="日期型" value="日期型" />
                    <el-option label="选项型" value="选项型" />
                  </el-select>
                </el-col>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8" v-if="item.new_parameter_type === '文本型'">
            <el-row>
              <el-col :span="7" class="right" style="text-align: right"
                >字段长度：</el-col
              >
              <el-col :span="10" style="text-align: left">
                <el-input-number
                  v-model="item.new_parameter_length"
                  class="input"
                  size="mini"
                  :min="0"
                  :disabled="isLock"
                />
              </el-col>
            </el-row>
          </el-col>

          <el-col :span="8" v-if="item.new_parameter_type === '日期型'">
            <el-row>
              <el-col :span="7" class="right" style="text-align: right"
                >日期格式：</el-col
              >
              <el-col :span="10" style="text-align: left">
                <el-select
                  v-model="item.register_new_type_condition"
                  class="input"
                  placeholder=" "
                  size="mini"
                  :disabled="isLock"
                >
                  <el-option label="年月日时分秒" value="年月日时分秒" />
                  <el-option label="年月日时分" value="年月日时分" />
                  <el-option label="年月日" value="年月日" />
                  <el-option label="年月" value="年月" />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="item" v-if="item.new_parameter_type === '选项型'">
          <el-col :span="8" style="text-align: left">
            <el-row>
              <el-col :span="7" class="right" style="text-align: right"
                >选项类型：</el-col
              >
              <el-col :span="10" class="rights">
                <el-select
                  v-model="item.new_parameter_time_type"
                  class="input"
                  placeholder=" "
                  size="mini"
                  :disabled="isLock"
                >
                  <el-option label="单选" value="单选" />
                  <el-option label="多选" value="多选" />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-row
            class="item"
            v-for="(parItem, parIndex) in item.new_parameter_layer_item_list"
            :key="parIndex"
          >
            <el-col :span="8" v-if="parIndex" style="opacity: 0">1</el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="6" class="right" style="text-align: right"
                  >选项编号：</el-col
                >
                <el-col :span="12">
                  <el-input
                    v-model="parItem.code"
                    class="input"
                    size="mini"
                    :disabled="isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row style="text-align: right">
                <el-col :span="12" class="right">选项描述：</el-col>
                <el-col :span="8">
                  <el-input
                    v-model="parItem.desc"
                    class="input"
                    size="mini"
                    :disabled="isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
    <!--随机号-->
    <div class="two">
      <div class="detail">
        <el-row class="item">
          <el-col :span="4" class="right">
            <el-input
              v-model="
                random_code_another_name === '其他'
                  ? random_other_name
                  : random_code_another_name
              "
              size="mini"
              type="text"
              :disabled="isLock"
            />
          </el-col>
          <el-col :span="12" class="rights">
            ：
            <el-radio-group
              v-model="random_code_another_name"
              :disabled="isLock"
            >
              <el-radio label="筛选号">筛选号</el-radio>
              <el-radio label="随机号">随机号</el-radio>
              <el-radio label="受试者ID">受试者ID</el-radio>
              <el-radio label="受试者编号">受试者编号</el-radio>
              <el-radio label="其他">其他</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="2">
            <el-input
              v-if="random_code_another_name === '其他'"
              v-model="random_other_name"
              size="mini"
              :disabled="isLock"
            />
          </el-col>
          <el-col :span="6" class="rights" style="text-align: center">
            <!-- <el-checkbox v-model="is_same" :disabled="isLock"
              >与{{
                choice_code_another_name === "其他"
                  ? other_name
                  : choice_code_another_name
              }}一致
            </el-checkbox> -->
            <el-checkbox
              v-model="is_random_code_system"
              :disabled="disAllRandom || isLock"
              @change="handleRan"
              >系统生成
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="8">
            <el-row>
              <el-col :span="7" class="right">是否需要前缀：</el-col>
              <el-col :span="12" class="rights">
                <el-radio-group
                  v-model="is_need_random_code_prefix"
                  :disabled="disAllRandom || isLock"
                  @change="handleSuffix"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-col>
          <template v-if="is_need_random_code_prefix">
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="6" class="right" style="text-align: right">
                  前缀：</el-col
                >
                <el-col :span="6">
                  <el-input
                    v-model="random_code_prefix"
                    size="mini"
                    :disabled="disAllRandom || isShowSuffix || isLock"
                  />
                </el-col>
                <el-col :span="12">
                  <el-select
                    v-model="random_code_prefix_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="disAllRandom || isShowSuffix || isLock"
                  >
                    <el-option
                      v-for="(item, q) in unit"
                      :key="q"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row style="text-align: right">
                <el-col :span="12" class="right">前缀分隔符：</el-col>
                <el-col :span="8">
                  <el-input
                    v-model="random_code_prefix_sep"
                    size="mini"
                    :disabled="disAllRandom || isShowSuffix || isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
          </template>
        </el-row>
        <el-row class="item" v-if="random_code_prefix_type === '手动输入'">
          <el-col :span="8" style="opacity: 0">123</el-col>
          <el-col :span="8">
            <el-row :gutter="5">
              <el-col :span="7" class="right" style="text-align: right">
                随机号前缀长度：</el-col
              >
              <el-col :span="6">
                <el-input-number
                  v-model="random_code_prefix_len"
                  :min="0"
                  size="mini"
                  :disabled="disAllRandom || isShowSuffix || isLock"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="8">
            <el-row>
              <el-col :span="6" class="right">编号长度：</el-col>
              <el-col :span="12">
                <el-input
                  v-model="random_code_len"
                  size="mini"
                  :disabled="disAllRandom || isLock"
                />
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row>
              <el-col :span="6" class="right" style="text-align: right"
                >起始编号：</el-col
              >
              <el-col :span="14">
                <el-input
                  v-model="random_code_start"
                  size="mini"
                  :disabled="disRandom || disAllRandom || isLock"
                />
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row style="text-align: right">
              <el-col :span="12" class="right">编号规则：</el-col>
              <el-col :span="8">
                <el-select
                  v-model="random_code_type"
                  placeholder="请选择"
                  :disabled="disRandom || disAllRandom || isLock"
                  size="mini"
                >
                  <el-option
                    v-for="(item, v) in choiceList"
                    :key="v"
                    :label="item.name"
                    :value="item.name"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="8">
            <el-row>
              <el-col :span="7" class="right">是否需要后缀：</el-col>
              <el-col :span="12" class="rights">
                <el-radio-group
                  v-model="is_need_random_code_suffix"
                  :disabled="disAllRandom || isLock"
                  @change="handelRandomName"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8" v-if="is_need_random_code_suffix">
            <el-row :gutter="5">
              <el-col :span="6" class="right" style="text-align: right"
                >后缀：</el-col
              >
              <el-col :span="6">
                <el-input
                  v-model="random_code_suffix"
                  size="mini"
                  :disabled="disAllRandom || suffixLast || isLock"
                />
              </el-col>
              <el-col :span="12">
                <el-select
                  v-model="random_code_suffix_type"
                  placeholder="请选择"
                  size="mini"
                  :disabled="disAllRandom || suffixLast || isLock"
                >
                  <el-option
                    v-for="(item, m) in choiceType"
                    :key="m"
                    :label="item.value"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="footer">
      <el-button
        v-preventReClick
        style="width: 100px"
        size="mini"
        type="primary"
        @click="save"
        :disabled="isLock"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { getProjectId, setFront, setAfter, getProDetail } from "@/utils/auth";
import { subjectSetting } from "@/api/subjects";
import { detailPro } from "@/api/platform";
export default {
  created() {
    this.proId = getProjectId();
    this.getData();
  },
  data() {
    return {
      active: 3,
      other_name: "", // 筛选号其他别名
      random_other_name: "",
      is_register_unique_choice_code: false, // 筛选号唯一标识项
      register_new_type_condition: "", //姓名缩写 长度选项
      //
      choice_code_another_name: "筛选号", // 筛选号别名设置
      random_code_another_name: "随机号", // 随机号：别名设置
      is_choice_code_system: false, // 筛选号 是否系统生成
      is_need_choice_code_prefix: true, // 是否需要受试者筛选号前缀
      choice_code_prefix: "", // 筛选号前缀
      choice_code_prefix_type: "", // 筛选号前缀类型
      choice_code_prefix_sep: "", // 筛选号前缀分隔
      // 前缀长度
      choice_code_len: null, // 筛选号编号长度
      choice_code_start: null, // 选号编号起始编号
      choice_code_type: "项目连续", // 筛选号编号规则
      is_need_choice_code_suffix: true, // 是否需要受试者筛选号后缀
      choice_code_suffix: "", //  筛选号后缀
      choice_code_suffix_type: "", // 筛选号后缀类型
      initials_len: 3, // 姓名缩写长度
      is_same: false, // 是否与筛选号一致
      is_random_code_system: true, // 随机号 是否系统生成
      is_need_random_code_prefix: true, // 是否需要随机号前缀
      register_is_prefix: 0,
      register_prefix: "",
      register_prefix_type: "",
      register_prefix_sep: "",
      register_prefix_length: 0,
      random_code_prefix: "", // 随机号前缀
      random_code_prefix_type: "", // 机号前缀类型
      random_code_prefix_len: 0,
      random_code_prefix_sep: "", // 随机号前缀分隔符
      random_code_len: null, // 随机号编号长度
      random_code_start: null, // 随机号编号起始编号
      random_code_type: "", // 随机号编号规则
      is_need_random_code_suffix: true, // 是否需要受试者随机号后缀
      random_code_suffix: "", // 随机号后缀
      random_code_suffix_type: "", // 随机号后缀类型
      initials_another_name: "", // 姓名缩写别名设置
      is_subject_show_system: true, // 受试者登记单，是否显示系统信息
      is_subject_show_time: true,
      is_subject_show_user: true,
      is_urgently_unblind_show_system: true, // 紧急
      is_urgently_unblind_show_time: true,
      is_urgently_unblind_show_user: true,
      unit: [{ name: "手动输入" }, { name: "单位编号" }, { name: "空" }],
      inputType: [{ name: "单位编号" }, { name: "空" }],
      choiceList: [{ name: "项目连续" }, { name: "中心连续" }],
      choiceType: [{ value: "姓名缩写" }, { value: "空" }],
      new_parameter_list: [],
      ageList: [
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 },
      ],
      disableSys: true,
      disPrefix: false,
      disSuffix: false,
      disRandom: true, // 随机号系统生成
      disAllRandom: false, // 与筛选号一致
      isShowSuffix: false,
      suffixLast: false,
      proId: "",
      isLock: false, // 锁定项目不可编辑,
      proDetail: getProDetail(),
    };
  },
  methods: {
    // 查询
    getData() {
      detailPro({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            //edc同步项目禁用
            if (res.data.is_synchro_edc) {
              this.isLock = true;
              this.new_parameter_list = res.data.new_parameter_list;
            }
            this.is_choice_code_system = res.data.is_choice_code_system;
            this.is_register_unique_choice_code =
              res.data.is_register_unique_choice_code;
            if (this.is_choice_code_system) {
              this.disableSys = false;
            } else {
              this.disableSys = true;
            }
            this.is_need_choice_code_prefix =
              res.data.is_need_choice_code_prefix;
            if (!this.is_need_choice_code_prefix) {
              this.disPrefix = true;
            }
            this.choice_code_prefix = res.data.choice_code_prefix;
            this.choice_code_prefix_type = res.data.choice_code_prefix_type;
            this.choice_code_prefix_sep = res.data.choice_code_prefix_sep;
            this.choice_code_len = res.data.choice_code_len;
            if (res.data.choice_code_start === "None") {
              this.choice_code_start = "";
            } else {
              this.choice_code_start = res.data.choice_code_start;
            }
            this.choice_code_type = res.data.choice_code_type;
            this.is_need_choice_code_suffix =
              res.data.is_need_choice_code_suffix;
            if (!this.is_need_choice_code_suffix) {
              this.disSuffix = true;
            }
            this.choice_code_suffix = res.data.choice_code_suffix;
            this.choice_code_suffix_type = res.data.choice_code_suffix_type;
            this.register_is_prefix = res.data.register_is_prefix;
            this.register_prefix = res.data.register_prefix;
            this.register_prefix_type = res.data.register_prefix;
            this.register_prefix_sep = res.data.register_prefix_sep;
            this.register_prefix_length = res.data.register_prefix_length;
            this.register_new_type_condition =
              res.data.register_new_type_condition;
            if (res.data.initials_len === 0) {
              this.initials_len = "";
            } else {
              this.initials_len = res.data.initials_len;
            }
            this.is_same = res.data.is_same;
            if (this.is_same) {
              this.disAllRandom = true;
            } else {
              this.disAllRandom = false;
            }
            this.is_random_code_system = res.data.is_random_code_system;
            if (this.is_random_code_system) {
              this.disRandom = false;
            } else {
              this.disRandom = true;
            }
            this.is_need_random_code_prefix =
              res.data.is_need_random_code_prefix;
            if (this.is_need_random_code_prefix) {
              this.isShowSuffix = false;
            } else {
              this.isShowSuffix = true;
            }
            this.random_code_prefix = res.data.random_code_prefix;
            this.random_code_prefix_type = res.data.random_code_prefix_type;
            this.random_code_prefix_len = res.data.random_code_prefix_len;
            this.random_code_prefix_sep = res.data.random_code_prefix_sep;
            this.random_code_len = res.data.random_code_len;
            if (res.data.random_code_start === "None") {
              this.random_code_start = "";
            } else {
              this.random_code_start = res.data.random_code_start;
            }
            this.random_code_type = res.data.random_code_type;
            this.is_need_random_code_suffix =
              res.data.is_need_random_code_suffix;
            if (!this.is_need_random_code_suffix) {
              this.suffixLast = true;
            }
            const another_names = [
              "筛选号",
              "随机号",
              "受试者ID",
              "受试者编号",
              "其他",
            ];
            this.random_code_suffix = res.data.random_code_suffix;
            this.random_code_suffix_type = res.data.random_code_suffix_type;
            this.choice_code_another_name = res.data.choice_code_another_name;
            if (!another_names.includes(res.data.choice_code_another_name)) {
              this.other_name = res.data.choice_code_another_name;
              this.choice_code_another_name = "其他";
            }

            this.random_code_another_name = res.data.random_code_another_name;

            if (!another_names.includes(res.data.random_code_another_name)) {
              this.random_other_name = res.data.random_code_another_name;
              this.random_code_another_name = "其他";
            }

            this.initials_another_name = res.data.initials_another_name;
            this.is_subject_show_system = res.data.is_subject_show_system;
            this.is_subject_show_time = res.data.is_subject_show_time;
            this.is_subject_show_user = res.data.is_subject_show_user;
            this.is_urgently_unblind_show_system =
              res.data.is_urgently_unblind_show_system;
            this.is_urgently_unblind_show_time =
              res.data.is_urgently_unblind_show_time;
            this.is_urgently_unblind_show_user =
              res.data.is_urgently_unblind_show_user;
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    isSystem(val) {
      if (val) {
        this.disableSys = false;
      } else {
        this.disableSys = true;
        this.choice_code_start = null;
        this.choice_code_type = "";
      }
    },
    handleIsPrefix(val) {
      if (val) {
        this.disPrefix = false;
      } else {
        this.disPrefix = true;
        this.choice_code_prefix = "";
        this.choice_code_prefix_type = "";
        this.choice_code_prefix_sep = "";
      }
    },
    handelIsSuffix(val) {
      if (val) {
        this.disSuffix = false;
      } else {
        this.disSuffix = true;
        this.choice_code_suffix = "";
        this.choice_code_suffix_type = "";
      }
    },
    handleRan(val) {
      if (val) {
        this.disRandom = false;
      } else {
        this.disRandom = true;
        this.random_code_start = null;
        this.random_code_type = "";
      }
    },
    handleSuffix(val) {
      if (val) {
        this.isShowSuffix = false;
      } else {
        this.isShowSuffix = true;
        this.random_code_prefix_type = "";
        this.random_code_prefix_len = 0;
        this.random_code_prefix = "";
        this.random_code_prefix_sep = "";
      }
    },
    handelRandomName(val) {
      if (val) {
        this.suffixLast = false;
      } else {
        this.suffixLast = true;
        this.random_code_suffix = "";
        this.random_code_suffix_type = "";
      }
    },
    save() {
      if (this.validate()) {
        const params = {
          id: this.proId,
          is_choice_code_system: this.is_choice_code_system,
          is_register_unique_choice_code: this.is_register_unique_choice_code,
          is_need_choice_code_prefix: this.is_need_choice_code_prefix,
          register_new_type_condition: this.register_new_type_condition,

          choice_code_prefix: this.choice_code_prefix,
          choice_code_prefix_type: this.choice_code_prefix_type,
          choice_code_prefix_sep: this.choice_code_prefix_sep,
          choice_code_len: this.choice_code_len,
          choice_code_start: this.choice_code_start,
          choice_code_type: this.choice_code_type,
          is_need_choice_code_suffix: this.is_need_choice_code_suffix,
          choice_code_suffix: this.choice_code_suffix,
          choice_code_suffix_type: this.choice_code_suffix_type,
          register_is_prefix: this.register_is_prefix,
          register_prefix: this.register_prefix,
          register_prefix_type: this.register_prefix,
          register_prefix_sep: this.register_prefix_sep,
          tregister_prefix_length: this.register_prefix_length,
          initials_len: this.initials_len,
          is_same: this.is_same,
          is_random_code_system: this.is_random_code_system,
          is_need_random_code_prefix: this.is_need_random_code_prefix,
          random_code_prefix: this.random_code_prefix,
          random_code_prefix_type: this.random_code_prefix_type,
          random_code_prefix_len: this.random_code_prefix_len,
          random_code_prefix_sep: this.random_code_prefix_sep,
          random_code_len: this.random_code_len,
          random_code_start: this.random_code_start,
          random_code_type: this.random_code_type,
          is_need_random_code_suffix: this.is_need_random_code_suffix,
          random_code_suffix: this.random_code_suffix,
          random_code_suffix_type: this.random_code_suffix_type,
          choice_code_another_name: this.choice_code_another_name,
          random_code_another_name: this.random_code_another_name,
          initials_another_name: this.initials_another_name,
          is_subject_show_system: this.is_subject_show_system,
          is_subject_show_time: this.is_subject_show_time,
          is_subject_show_user: this.is_subject_show_user,
          is_urgently_unblind_show_system: this.is_urgently_unblind_show_system,
          is_urgently_unblind_show_time: this.is_urgently_unblind_show_time,
          is_urgently_unblind_show_user: this.is_urgently_unblind_show_user,
        };
        this.add(params);
      }
    },
    add(params) {
      setFront(params.is_choice_code_system);
      setAfter(params.is_random_code_system);
      console.log(params);
      subjectSetting(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getData();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    validate() {
      if (!this.choice_code_another_name) {
        this.$message({
          message: "请填写筛选号名称",
          type: "warning",
        });
        return false;
      }
      if (this.is_choice_code_system) {
        if (!this.choice_code_start) {
          this.$message({
            message: "请填写起始编号",
            type: "warning",
          });
          return false;
        }
        if (!this.choice_code_type) {
          this.$message({
            message: "请选择起始编号类型",
            type: "warning",
          });
          return false;
        }
      }
      if (this.is_need_choice_code_prefix) {
        // if (!this.choice_code_prefix) {
        //   this.$message({
        //     message: '请填写前缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.choice_code_prefix_type) {
          this.$message({
            message: "请选择前缀类型",
            type: "warning",
          });
          return false;
        }
        // if (!this.choice_code_prefix_sep) {
        //   this.$message({
        //     message: '请填写前缀分隔符',
        //     type: 'warning'
        //   })
        //   return false
        // }
      }
      if (!this.choice_code_len) {
        this.$message({
          message: "请填写筛选号长度",
          type: "warning",
        });
        return false;
      }
      if (this.is_need_choice_code_suffix) {
        // if (!this.choice_code_suffix) {
        //   this.$message({
        //     message: '请填写后缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.choice_code_suffix_type) {
          this.$message({
            message: "请选择后缀类型",
            type: "warning",
          });
          return false;
        }
      }
      if (!this.initials_len) {
        this.$message({
          message: "请选择姓名缩写长度",
          type: "warning",
        });
        return false;
      }
      if (!this.register_new_type_condition) {
        this.$message({
          message: "请选择姓名缩写长度选项",
          type: "warning",
        });
        return false;
      }
      if (!this.random_code_another_name) {
        this.$message({
          message: "请填写随机号",
          type: "warning",
        });
        return false;
      }
      if (this.is_random_code_system) {
        if (!this.random_code_start) {
          this.$message({
            message: "请填写起始编号",
            type: "warning",
          });
          return false;
        }
        if (!this.random_code_type) {
          this.$message({
            message: "请选择编号规则",
            type: "warning",
          });
          return false;
        }
      }
      if (this.is_need_random_code_prefix) {
        // if (!this.random_code_prefix) {
        //   this.$message({
        //     message: '请填写前缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.random_code_prefix_type) {
          this.$message({
            message: "请选择前缀类型",
            type: "warning",
          });
          return false;
        }
        // if (!this.random_code_prefix_sep) {
        //   this.$message({
        //     message: '请填写前缀分隔符',
        //     type: 'warning'
        //   })
        //   return false
        // }
      }
      if (!this.random_code_len) {
        this.$message({
          message: "请填写编号长度",
          type: "warning",
        });
        return false;
      }
      if (this.is_need_random_code_suffix) {
        // if (!this.random_code_suffix) {
        //   this.$message({
        //     message: '请填写后缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.random_code_suffix_type) {
          this.$message({
            message: "请选择后缀类型",
            type: "warning",
          });
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
.setting {
  margin-bottom: 30px;
}

.title {
  font-size: 16px;
  color: #595959;
  font-weight: 500;
  margin-bottom: 10px;
}

.item {
  padding: 10px 0;
}

.detail {
  margin: 0 30px;
}

.right {
  /*text-align: right;*/
  line-height: 26px;
  /*border: 1px solid red;*/
}

.circle {
  width: 8px;
  height: 8px;
  background-color: #8eb1ff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.first {
  padding-bottom: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.two {
  margin-top: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.three {
  border-bottom: 1px dashed #bfbfbf;
  padding: 15px 0;
}

.four {
  margin-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.rights {
  line-height: 26px;
}

.footer {
  text-align: center;
  margin-top: 30px;
}

.detailTitle {
  font-size: 15px;
  font-weight: 500;
}

.el-button:first-child {
  width: 6.2%;
  margin-right: 20px;
}

.detailBox {
  margin-bottom: 30px;
}
</style>
